import React, { useEffect, useRef, useState } from 'react';
import { useInView, animate } from 'framer-motion';

interface CounterProps {
  value: string; // e.g. "500+", "1000+"
  className?: string;
}

/** Counts up from 0 when scrolled into view. Parses "500+" into 500 and "+". */
const Counter = ({ value, className = '' }: CounterProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  const target = parseInt(value.replace(/\D/g, ''), 10) || 0;
  const suffix = value.replace(/[\d,\s]/g, '');
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, target, {
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, target]);

  return (
    <span ref={ref} className={className}>
      {display.toLocaleString()}
      {suffix}
    </span>
  );
};

export default Counter;
